import { Button, Modal } from "@design";
import { useTranslation } from "react-i18next";
import { Text } from "@/components/Text";
import { useDeleteWikiFile } from "./useWiki";

/** Confirm, then delete a page at the revision the reader is looking at. History is kept. */
export function DeletePageModal({
  spaceUuid,
  path,
  title,
  revision,
  onClose,
  onDeleted,
}: Readonly<{
  spaceUuid: string;
  path: string;
  title: string;
  revision: number;
  onClose: () => void;
  onDeleted: () => void;
}>) {
  const { t } = useTranslation("knowledge");
  const remove = useDeleteWikiFile(spaceUuid, onDeleted);
  return (
    <Modal
      open
      onClose={onClose}
      title={t("remove.title")}
      actions={
        <>
          <Button variant="secondary" onClick={onClose}>
            {t("editor.cancel")}
          </Button>
          <Button
            variant="danger"
            loading={remove.isPending}
            onClick={() => remove.mutate({ path: { space_uuid: spaceUuid }, query: { path, baseRevision: revision } })}
          >
            {t("remove.confirm")}
          </Button>
        </>
      }
    >
      <Text>{t("remove.body", { title })}</Text>
    </Modal>
  );
}
